//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Badge from "@Shared/components/general/badge.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { startCase } from "lodash";
import { SORT_ORDER_E } from "@Shared/js/enum";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientBoardSort",
  components: {
    Badge
  },
  props: {
    sortBy: {
      type: String,
      default: "none"
    },
    noActivityFirst: {
      type: Boolean,
      default: false
    },
    sortByOrder: {
      type: String,
      default: SORT_ORDER_E.asc,
      validator: prop => prop === SORT_ORDER_E.asc || prop === SORT_ORDER_E.desc
    }
  },
  computed: {
    sortName() {
      return this.$t("boards.filters")[this.sortBy] || startCase(this.sortBy);
    },
    sortByOrderIcon() {
      return this.sortByOrder === SORT_ORDER_E.asc ? "arrow-up" : "arrow-down";
    },
    isSortByDateCreated() {
      return this.sortBy === "createdAt";
    },
    isSortByClientValue() {
      return this.sortBy === "clientValue";
    },
    isSortByClientLabel() {
      return this.sortBy === "clientLabel";
    },
    sortByOrderTooltip() {
      let order = "";
      if (this.sortBy === "createdAt") {
        order = this.sortByOrder === SORT_ORDER_E.asc ? "oldestToNewest" : "newestToOldest";
      } else if (this.sortBy === "clientValue") {
        order = this.sortByOrder === SORT_ORDER_E.asc ? "lowestToHighest" : "highestToLowest";
      } else {
        order = this.sortByOrder === SORT_ORDER_E.asc ? "aToZ" : "zToA";
      }
      return this.$t(`boards.filters.${order}`);
    }
  },
  methods: {
    handleSortBy(sortByChanged) {
      this.notifyChange({
        sortBy: sortByChanged,
        noActivityFirst: this.noActivityFirst
      });
    },
    handleActivityFirstChange() {
      this.notifyChange({
        sortBy: this.sortBy,
        noActivityFirst: !this.noActivityFirst
      });
    },
    notifyChange(sortData) {
      this.$emit("change", sortData);
      Amplitude.logEvent("Board - sort changed", {
        data: sortData
      });
    },
    handleChangeSortByOrder() {
      this.notifyChange({
        sortBy: this.sortBy,
        noActivityFirst: this.noActivityFirst,
        sortByOrder: this.sortByOrder === SORT_ORDER_E.asc ? SORT_ORDER_E.desc : SORT_ORDER_E.asc
      });
    }
  }
});